<ng-container *ngIf="['btn-primary', 'btn-secondary'].includes(cssType())">
    <ng-container *ngIf="buttonType() === 'button'">
      <button type="{{type()}}" [ngClass]="[cssType(), getSizeClass(), getWidthClass()]"
      [disabled]="disabledComputed()"
      (click)="temporarilyDisable()">
        {{ text() }}
        <span *ngIf="icon()" class="pl-2">
          <lib-icon [icon]="icon()" class="icon"></lib-icon>
        </span>
      </button>
    </ng-container>
  
    <ng-container *ngIf="buttonType() === 'link' && externalLink()">
      <a
        href="{{href()}}" 
        target="_blank"
        [ngClass]="[cssType(), getSizeClass(), getWidthClass(), isDisabled()]"
        [attr.tabindex]="disabled() ? -1 : null"
        [attr.aria-disabled]="disabledComputed() ? 'true' : null"
        [attr.href]="disabled() ? null : href()"
        (click)="temporarilyDisable()"
      >
        {{ text() }}
        <span *ngIf="icon()" class="pl-2">
          <lib-icon [icon]="icon()" class="icon"></lib-icon>
        </span>
      </a>
    </ng-container>
  
    <ng-container *ngIf="buttonType() === 'link' && !externalLink()">
      <a
        [routerLink]="disabled() ? null : routerLink()"
        [ngClass]="[cssType(), getSizeClass(), getWidthClass(), isDisabled()]"
        [attr.tabindex]="disabled() ? -1 : null"
        [attr.aria-disabled]="disabledComputed() ? 'true' : null"
        (click)="temporarilyDisable()"
      >
        {{ text() }}
        <span *ngIf="icon()" class="pl-2">
          <lib-icon [icon]="icon()" class="icon"></lib-icon>
        </span>
      </a>
    </ng-container>
</ng-container>
  
<ng-container *ngIf="cssType() === 'btn-link'">
    <ng-container *ngIf="buttonType() === 'button'">
        <button type="{{type()}}" class="btn-link"
        [ngClass]="[cssType(), getSizeClass(), isBold()]" 
        [disabled]="disabledComputed()"
        (click)="temporarilyDisable()">
          <span *ngIf="icon()">
            <lib-icon  [icon]="icon()" class="icon" ></lib-icon>
            </span>
            <span [ngClass]="{'pl-2': icon()}">
                {{text()}}
            </span>
        </button>
    </ng-container>

    <ng-container *ngIf="buttonType() === 'link' && externalLink()">
        <a
          href="{{href()}}" 
          target="_blank"
          [ngClass]="[cssType(), getSizeClass(), isBold(), isDisabled()]"
          [attr.tabindex]="disabled() ? -1 : null"
          [attr.aria-disabled]="disabledComputed() ? 'true' : null"
          [attr.href]="disabled() ? null : href()"
          (click)="temporarilyDisable()"
        >
        <span *ngIf="icon()">
            <lib-icon  [icon]="icon()" class="icon" ></lib-icon>
            </span>
            <span [ngClass]="{'pl-2': icon()}">
                {{text()}}
            </span>
        </a>
    </ng-container>
    
    <ng-container *ngIf="buttonType() === 'link' && !externalLink()">
    <a
        [routerLink]="disabled() ? null : routerLink()"
        [ngClass]="[cssType(), getSizeClass(), isBold(), isDisabled()]"
        [attr.tabindex]="disabled() ? -1 : null"
        [attr.aria-disabled]="disabledComputed() ? 'true' : null"
        (click)="temporarilyDisable()"
    >
    <span *ngIf="icon()">
        <lib-icon  [icon]="icon()" class="icon" ></lib-icon>
        </span>
        <span [ngClass]="{'pl-2': icon()}">
            {{text()}}
        </span>
    </a>
    </ng-container>
</ng-container>

<ng-container *ngIf="cssType() === 'btn-dropdown'">
  <div class="btn-dropdown">
    <div class="btn-group">
        <button type="button" class="btn-main text"  (click)="mainClick.emit(); temporarilyDisable();"
            [disabled]="disabledComputed()">{{text()}}</button>
        <button type="button" class="btn-main dropdown" data-bs-toggle="dropdown" aria-expanded="false"
            (click)="toggleDropdown()" [disabled]="dropdownDisabled()">
            <lib-icon [icon]="icon()" class="icon"></lib-icon>
        </button>

        <ul *ngIf="showDropdown" class="dropdown-menu">
            @for(item of menuItems(); track item) {
              <div class="inner-button-wrapper">

                <button class="dropdown-item" [type]="item.type || 'button'" [routerLink]="item.link"
                (click)="onItemClick(item); temporarilyDisable();" [disabled]="item.disabled">{{item.name}}</button>
              </div>
            }
        </ul>
    </div>
</div>
</ng-container>

<ng-container *ngIf="cssType() === 'btn-close'">
  <button 
      *ngIf="closeType() === 'modal'"
      class="btn-close"
      type="{{type()}}"
      [ngClass]="{'modal-exit': closeType() === 'modal'}" 
      (click)="close()">
      <span>
          close
      </span>
      <lib-icon [icon]="icon()" class="icon"></lib-icon>
  </button>

  <button 
      *ngIf="closeType() === 'notification'"
      type="{{type()}}"
      class="btn-notifaction-close"
      [ngClass]="{'notification-exit': closeType() === 'notification'}" 
      (click)="close()">
      <lib-icon [icon]="icon()" class="icon"></lib-icon>
  </button>

  <button 
      *ngIf="closeType() === 'snackbar'"
      class="btn-snackbar-close"
      type="{{type()}}"
      (click)="close()"
      >
      <lib-icon [icon]="icon()" class="icon"></lib-icon>
  </button>
</ng-container>

<ng-container *ngIf="cssType() === 'btn-icon'">
  <ng-container *ngIf="buttonType() === 'button'">
    <button class="btn-icon"
    type="{{type()}}"
    [ngClass]="[cssType()]" 
    (click)="temporarilyDisable()"
    [disabled]="disabledComputed()">
        <lib-icon  [icon]="icon()" class="icon" ></lib-icon>
    </button>
  </ng-container>

  <ng-container *ngIf="buttonType() === 'link' && externalLink()">
      <a
        href="{{href()}}" 
        target="_blank"
        [ngClass]="[cssType(), isDisabled()]"
        [attr.tabindex]="disabled() ? -1 : null"
        [attr.aria-disabled]="disabledComputed() ? 'true' : null"
        [attr.href]="disabled() ? null : href()"
        (click)="temporarilyDisable()"
      >
        <lib-icon  [icon]="icon()" class="icon" ></lib-icon>
      </a>
  </ng-container>

  <ng-container *ngIf="buttonType() === 'link' && !externalLink()">
  <a
      [routerLink]="disabled() ? null : routerLink()"
      [ngClass]="[cssType(), isDisabled()]"
      [attr.tabindex]="disabled() ? -1 : null"
      [attr.aria-disabled]="disabledComputed() ? 'true' : null"
      (click)="temporarilyDisable()"
  >
    <lib-icon  [icon]="icon()" class="icon" ></lib-icon>
  </a>
  </ng-container>
</ng-container>

<ng-container *ngIf="cssType() === 'btn-icon-dropdown'">
  <div class="btn-dropdown">
    <div class="btn-group">
        <button #dropdownButton class="btn-icon"
        type="{{type()}}"
        ngClass="btn-icon" 
        data-bs-toggle="dropdown"
        [disabled]="disabled()"
        (click)="toggleDropdown()">
            <lib-icon  [icon]="icon()" class="icon" ></lib-icon>
        </button>

        <ul #dropdownMenu *ngIf="showDropdown" class="dropdown-menu w-auto"
            [ngStyle]="getDropdownMenuStyle()"
            (clickOutside)="showDropdown = false">
          @for(item of menuItems(); track item) {
              <div class="inner-button-wrapper">
                <button class="dropdown-item" [type]="item.type || 'button'" [routerLink]="item.link"
                (click)="onItemClick(item); temporarilyDisable();" [disabled]="item.disabled || disabledComputed()">{{item.name}}</button>
              </div>
            }
        </ul>
    </div>
</div>
</ng-container>
